import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'vargus',
} as IModuleProps;
